export const PENDING_FOLDER_ID_PREFIX = 'pending-';
export function buildPendingFolder(folders, input) {
    var _a, _b, _c;
    const parentKey = (_a = input.parentFolderId) !== null && _a !== void 0 ? _a : null;
    let sortOrder = 0;
    for (const f of folders) {
        if (((_b = f.parentFolderId) !== null && _b !== void 0 ? _b : null) === parentKey) {
            sortOrder = Math.max(sortOrder, f.sortOrder + 1);
        }
    }
    return {
        id: input.id,
        projectId: input.projectId,
        ownerUserId: '',
        name: input.name,
        color: input.color,
        sortOrder,
        createdAt: input.now,
        updatedAt: input.now,
        parentFolderId: (_c = input.parentFolderId) !== null && _c !== void 0 ? _c : undefined,
        artifacts: [],
        pending: true,
    };
}
export function appendPendingFolder(folders, input) {
    return [...folders, buildPendingFolder(folders, input)];
}
// A refetch may have dropped the temp record or already delivered the real
// folder; never leave two records with the same id.
export function resolvePendingFolder(folders, tempId, created) {
    const hasReal = folders.some(f => f.id === created.id);
    const hasTemp = folders.some(f => f.id === tempId);
    if (!hasTemp)
        return hasReal ? folders : [...folders, { ...created, artifacts: [] }];
    if (hasReal)
        return folders.filter(f => f.id !== tempId);
    return folders.map(f => (f.id === tempId ? { ...created, artifacts: [] } : f));
}
export function removePendingFolder(folders, tempId) {
    return folders.filter(f => f.id !== tempId);
}
export function mergeFetchedFolders(fetched, current) {
    return [...fetched, ...current.filter(f => f.pending)];
}
export function moveKey(record, fromKey, toKey, fallback) {
    const next = { ...record, [toKey]: fromKey in record ? record[fromKey] : fallback };
    delete next[fromKey];
    return next;
}
export function dropKey(record, key) {
    const next = { ...record };
    delete next[key];
    return next;
}
